// extracted by mini-css-extract-plugin
export var deskImage = "InfographicsHero-module--desk-image--04e2c";
export var desktopImg = "InfographicsHero-module--desktopImg--2f79e";
export var heroImg = "InfographicsHero-module--hero-img--884e2";
export var hide = "InfographicsHero-module--hide--65829";
export var imgContainer = "InfographicsHero-module--imgContainer--3c052";
export var mobImage = "InfographicsHero-module--mob-image--668e2";
export var mobileImage = "InfographicsHero-module--mobileImage--3deca";
export var title = "InfographicsHero-module--title--8c97c";